import React from 'react'
import AdminNavBar from '../AdminNavBar'
import NavLogo from '../NavLogo'
import ReportNavbar from './ReportNavbar'
import { Col, Row } from 'react-bootstrap'

const ReportDashboard = () => {
    const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  return (
    <div>
    <AdminNavBar />
    <section className="home-section">
        <NavLogo />
        <ReportNavbar />

        <Row className="m-0 p-0 pt-4 px-md-4 px-2">
            <Col
                className=" rounded text-center pt-2"
                style={{
                    display: "flex",
                    justifyContent: "start",
                    backgroundColor: "white",
                    border: "0px",
                    alignItems: "center",
                    alignContent: "center",
                    color: " rgb(47, 79, 79)",
                }}
            >    
                <h5>{selectedLanguage === 'Marathi' ? 'डॅशबोर्ड' : 'Dashboard'}</h5>
            </Col>
        </Row>

</section>
    </div>
  )
}

export default ReportDashboard
